import React from "react";
import { StyledContainer } from "./styles";

interface ToggleProps extends React.InputHTMLAttributes<HTMLInputElement> {
  set?: (checked: boolean) => void;
  checked: boolean;
}

export default function Toggle({
  set,
  checked,
  tabIndex,
  ...props
}: ToggleProps) {
  const hasSet = typeof set === "function";

  return (
    <StyledContainer className={hasSet ? undefined : "display-only"}>
      <label className="switch">
        <input
          type="checkbox"
          checked={checked}
          tabIndex={hasSet ? tabIndex : -1}
          onClick={(e) => {
            if (hasSet) {
              e.stopPropagation();
              set((e.target as HTMLInputElement).checked);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && hasSet) {
              e.preventDefault();
              set(!checked);
            }
          }}
          onChange={() => {}}
          {...props}
        />
        <span className="slider round"></span>
      </label>
    </StyledContainer>
  );
}
